module.exports = __webpack_public_path__ + "img/public/AdminIcons/edit.svg?9466c438";